import { useAuthentication } from '@zenbusiness/application-commons-authentication';

import { CHECKOUT } from '../constants';

/**
 * Custom hook to determine the checkout step sequence.
 *
 * @returns {Array} The sequence of steps for the checkout process.
 */
export function useCheckoutSteps() {
  const { authenticated } = useAuthentication();

  if (authenticated) {
    return CHECKOUT.STEP_ORDER_HAS_AUTH_ACCOUNT;
  }

  return CHECKOUT.STEP_ORDER;
}
